var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11.25,
    stroke: "currentColor",
    strokeOpacity: 0.2,
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7095 8.07831C10.6397 8.03014 10.5592 8.00319 10.4765 8.00027C10.3938 7.99734 10.3119 8.01856 10.2394 8.0617C10.1669 8.10484 10.1064 8.16831 10.0643 8.24547C10.0221 8.32263 9.99995 8.41064 10 8.50028V15.4997C9.99995 15.5894 10.0221 15.6774 10.0643 15.7545C10.1064 15.8317 10.1669 15.8952 10.2394 15.9383C10.3119 15.9814 10.3938 16.0027 10.4765 15.9997C10.5592 15.9968 10.6397 15.9699 10.7095 15.9217L15.786 12.422C15.8516 12.3768 15.9056 12.3145 15.943 12.2407C15.9804 12.167 16 12.0842 16 12C16 11.9158 15.9804 11.833 15.943 11.7593C15.9056 11.6855 15.8516 11.6232 15.786 11.578L10.7095 8.07831Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.e25ca631edaa04d6d716c2f55c6c64e6.svg";
export { ForwardRef as ReactComponent };